import routes from "../../../routes/routes.js";
import { Link } from "react-router-dom";
import Collapse from "bootstrap/js/dist/collapse";

export default function NfcNavbar({ itemNumber }) {
  return (
    <nav className="navbar d-flex justify-content-between align-items-center">
      <p className="mb-0">FANCY MONAS</p>

      <button
        className={`navbar-toggler`}
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#miMenu"
        aria-controls="miMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className={`navbar-toggler-icon navbarTogglerIcon`}></span>
      </button>

      <div className={`collapse navbar-collapse navbarCollapse`} id="miMenu">
        <div className="nfcContainer">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <button
                className="btn btn-link p-0 text-white mb-4"
                type="button"
                onClick={() => {
                  const myMenu = document.getElementById("miMenu");
                  const collapse = new Collapse(myMenu, { toggle: false });
                  collapse.hide();
                }}
                aria-label="Close menu"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 2L16 16"
                    stroke="#fff"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M2 2L16 16"
                    stroke="#fff"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M2 16L16 2"
                    stroke="#fff"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M2 16L16 2"
                    stroke="#fff"
                    stroke-width="4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </li>
            <li className="nav-item">
              <span>01</span>
              <Link
                to={`${routes.nfc}/${itemNumber}`}
                className={`nav-link navLink`}
              >
                OBRA
              </Link>
            </li>
            <li className="nav-item">
              <span>02</span>
              <Link
                className={`nav-link navLink`}
                to={`${routes.certificate}/${itemNumber}`}
              >
                CERTIFICADO
              </Link>
            </li>
            <li className="nav-item inactive">
              <span>03</span>
              <a className={`nav-link navLink `} href="#">
                PROYECTO
              </a>
            </li>
            <li className="nav-item inactive">
              <span>04</span>
              <a className={`nav-link navLink`} href="#">
                ARTISTA
              </a>
            </li>
            <li className="nav-item inactive">
              <span>05</span>
              <a className={`nav-link navLink`} href="#">
                NOVEDADES
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
